/* Swiss Notes — final product-page Add to Set paint.
   royal-ui-enhancements paints this control inline, so this small theme-specific
   pass runs after that painter and keeps the requested WhatsApp green stable. */
(() => {
  'use strict';

  const isShopifyPreview =
    Boolean(window.Shopify && (Shopify.designMode || Shopify.visualPreviewMode)) ||
    new URLSearchParams(window.location.search).has('preview_theme_id') ||
    /admin\.shopify\.com|\/admin\/themes\//i.test(document.referrer);

  if (isShopifyPreview) {
    document.documentElement.classList.add('sn-shopify-preview');
  }

  const GREEN = '#25D366';
  const WHITE = '#FFFFFF';

  const paintGreen = () => {
    document.querySelectorAll('.buy-buttons .sn-set-add').forEach((button) => {
      button.style.setProperty('background', GREEN, 'important');
      button.style.setProperty('background-color', GREEN, 'important');
      button.style.setProperty('background-image', 'none', 'important');
      button.style.setProperty('border-color', GREEN, 'important');
      button.style.setProperty('color', WHITE, 'important');
      button.style.setProperty('-webkit-text-fill-color', WHITE, 'important');
      button.style.setProperty('opacity', '1', 'important');
    });
  };

  const paintAfterOtherThemeScripts = () => requestAnimationFrame(paintGreen);

  const start = () => {
    paintGreen();

    /* The set button is injected dynamically. Observe only DOM insertions so
       our own style writes cannot trigger an observer loop. */
    if (document.body) {
      new MutationObserver(paintAfterOtherThemeScripts)
        .observe(document.body, { childList: true, subtree: true });
    }

    /* royal-ui-enhancements also repaints on clicks and delayed passes. Queue
       ours afterwards so green remains the final rendered state. */
    document.addEventListener('click', paintAfterOtherThemeScripts, true);
    [350, 1100, 2600].forEach((ms) => setTimeout(paintGreen, ms));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
